import React, { useState, useEffect } from "react";
import { Button } from "reactstrap";
import { toast } from "react-toastify";
import moment from "moment";
import useFetcher from "../../../hooks/useFetcher";
import { getAllOutOfOffice, getPisActivos, getOutOfOfficeCatrgories, updateOutOfOffice, getTokenOfPiOutOfOffice } from "../../../services/outOfOfficeServices";
import OutOfOfficeModal from "../../OutOfOffice/OutOfOficceModal";
import { BlurSpinner } from "../../BlurSpinner";
import { formatearFecha } from "../../CandidatosNP/utils";
import { fetchPiAsignable } from "../../../services/ticketingServices";

const searchOutOfOfficeRegisterByHolder = (registers, holder) => {
  return registers && registers.filter((item) => item.titular === holder);
};

const searchOutOfOfficeRegisterByReplacement = (registers, holder) => {
  return registers && registers.filter((item) => item.remplazo === holder);
};

const searchReplacementName = (piActivos, replacement) => {
  const pi = piActivos && piActivos.find((item) => item.itemId === replacement);
  return pi ? pi.nombreApellido : null;
};

const searchHolderName = (pis, holder) => {
  const pi = pis && pis.find((item) => item.itemId === holder);
  return pi ? pi.nombreApellido : null;
};

const getColorByStatus = (status) => {
  switch (status) {
    case 1:
      return "green";
    case 2:
      return "red";
    case 3:
      return "orange";
    default:
      return "grey";
  }
};

const getOutOfOfficeStatus = (status, categories) => {
  const category = categories.find((item) => item.id === status);
  return category ? category.text : null;
};

const OutOfOffice = ({ currentUser }) => {
  const fechaActual = moment().format("YYYY-MM-DD");
  const [piActivos, isLoadingPis] = useFetcher(getPisActivos, undefined, "getPisActivos");
  const [allPis, isLoadingAllPis] = useFetcher(fetchPiAsignable, undefined, "fetchPiAsignable");
  const [outOfOfficeRegisters, isLoadingOutOfOfficeRegisters, , , fetchOutOfOffice] = useFetcher(getAllOutOfOffice, undefined);
  const [categories, isLoadingCategories] = useFetcher(getOutOfOfficeCatrgories, undefined, "getOutOfOfficeCatrgories");
  const statusType = categories && categories.type;
  const [openModal, setOpenModal] = useState(false);
  const [currentOutOfOffice, setCurrentOutOfOffice] = useState(null);
  const [currentRemplacing, setCurrentReplacing] = useState(null);
  const [estado, setEstado] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const originalUser = JSON.parse(localStorage.getItem("original-authUser"));

  useEffect(() => {
    if (outOfOfficeRegisters && outOfOfficeRegisters.rows && outOfOfficeRegisters.rows.length > 0 && currentUser && currentUser.user) {
      const result = searchOutOfOfficeRegisterByHolder(outOfOfficeRegisters.rows, currentUser.user.Pi.itemId);
      if (result && result.length > 0) {
        const filteredResult = result.filter((item) => new Date(item.fechaFin) >= new Date());
        if (filteredResult && filteredResult.length > 0) {
          setCurrentOutOfOffice(filteredResult[0]);
          setEstado(filteredResult[0].estado);
        }
      }
    }
  }, [outOfOfficeRegisters, currentUser]);

  useEffect(() => {
    if (outOfOfficeRegisters && outOfOfficeRegisters.rows && outOfOfficeRegisters.rows.length > 0 && currentUser && currentUser.user) {
      const result = searchOutOfOfficeRegisterByReplacement(outOfOfficeRegisters.rows, currentUser.user.Pi.itemId);

      if (result && result.length > 0) {
        const filteredResult = result.filter((item) => new Date(item.fechaFin) >= new Date() && item.estado !== 2);

        setCurrentReplacing(filteredResult);
      }
    }
  }, [outOfOfficeRegisters, currentUser]);

  const handleReenviarSolicitud = async () => {
    setIsLoading(true);
    const newOutOfOffice = {
      id: currentOutOfOffice.id,
      estado: 3,
      remplazo: currentOutOfOffice.remplazo,
    };
    const res = await updateOutOfOffice(newOutOfOffice);
    if (res.isSoftError) {
      toast.error(res.message);
    } else {
      fetchOutOfOffice();
      toast.success(res.message);
    }
    setIsLoading(false);
  };

  const handleChangeProfile = async (remplacing) => {
    setIsLoading(true);
    const titular = remplacing && remplacing.titular;
    const res = await getTokenOfPiOutOfOffice(titular);

    if (originalUser) {
      localStorage.setItem("authUser", JSON.stringify(originalUser));
      localStorage.removeItem("original-authUser");
      window.location.reload();
      return;
    }

    if (res.result) {
      localStorage.setItem("original-authUser", JSON.stringify(currentUser));
      localStorage.setItem("authUser", JSON.stringify(res.result));
      window.location.reload();
    }
    setIsLoading(false);
  };

  const handleAceptedOrRejected = async (status, remplacing) => {
    setIsLoading(true);
    const newOutOfOffice = {
      id: remplacing.id,
      estado: status,
    };
    const res = await updateOutOfOffice(newOutOfOffice);
    if (res.isSoftError) {
      toast.error(res.message);
    } else {
      if (status === 1) {
        toast.success("Solicitud aceptada");
      } else if (status === 2) {
        toast.warning("Solicitud rechazada");
      } else {
        toast.success(res.message);
      }
      fetchOutOfOffice();
    }
    setIsLoading(false);
  };

  return (
    <div className="card dmx-card-mt flex-grow-1" style={{ height: "fit-content" }}>
      {openModal && (
        <OutOfOfficeModal
          isOpen={openModal}
          toggle={() => {
            setOpenModal(!openModal);
          }}
          currentOutOfOffice={currentOutOfOffice}
          piActivos={piActivos}
          fetchOutOfOffice={fetchOutOfOffice}
        />
      )}
      <div className="card-header d-flex justify-content-between border-0" style={{ padding: "30px 30px 10px" }}>
        <h5>FUERA DE OFICINA</h5>
        <Button disabled={estado === 1} color="primary" onClick={() => setOpenModal(!openModal)} className="btn btn-primary" style={{ height: "35px" }}>
          Configurar fuera de oficina
        </Button>
      </div>
      {currentOutOfOffice && !originalUser && (
        <BlurSpinner isLoading={isLoadingOutOfOfficeRegisters || isLoadingPis || isLoadingCategories || isLoading}>
          <div className="m-4">
            <div className="d-flex justify-content-start align-items-center">
              <div className="border rounded p-2 px-4 mr-2">
                <h6 style={{ fontWeight: "bold", color: "var(--primary)" }}>Periodo</h6>
                <p className="m-0">
                  {`${currentOutOfOffice && currentOutOfOffice.fechaComienzo ? formatearFecha(currentOutOfOffice.fechaComienzo) : ""} - ${
                    currentOutOfOffice && currentOutOfOffice.fechaFin ? formatearFecha(currentOutOfOffice.fechaFin) : ""
                  }`}
                </p>
              </div>
              <div className="border rounded p-2 px-4 mr-2">
                <h6 style={{ fontWeight: "bold", color: "var(--primary)" }}>Reemplazo</h6>
                <p className="m-0">
                  {currentOutOfOffice && piActivos && piActivos.rows && searchReplacementName(piActivos && piActivos.rows, currentOutOfOffice.remplazo)}
                </p>
              </div>
              <div className="p-2 px-4">
                <h6
                  style={{
                    fontWeight: "bold",
                    fontSize: "18px",
                    color: getColorByStatus(currentOutOfOffice && categories && categories.type && estado),
                  }}
                >
                  {currentOutOfOffice && categories && statusType && getOutOfOfficeStatus(currentOutOfOffice.estado, statusType)}
                </h6>
                <button className="btn" type="button" onClick={handleReenviarSolicitud} disabled={estado !== 2}>
                  Reenviar solicitud
                </button>
              </div>
            </div>
          </div>
        </BlurSpinner>
      )}

      {currentRemplacing &&
        currentRemplacing.length > 0 &&
        currentRemplacing.map((item) => {
          if (!item || originalUser) return null;

          return (
            <BlurSpinner key={item.id} isLoading={isLoadingAllPis || isLoading}>
              <div className="border rounded m-2 p-2">
                <div className="d-flex flex-wrap justify-content-start align-items-center m-1">
                  <div className="d-flex">
                    {item.estado === 1 ? (
                      <div>
                        <div className="d-flex">
                          <h6 className="mr-2 mb-2" style={{ color: "var(--primary)" }}>
                            {item.fechaComienzo >= fechaActual ? `A partir de ${formatearFecha(item.fechaComienzo)} vas a reemplazar a:` : "Estás reemplazando a:"}
                          </h6>
                          <p className="mb-2" style={{ fontWeight: "bold", fontSize: "14px" }}>
                            {searchHolderName(allPis, item.titular)}
                          </p>
                        </div>
                        <div className="d-flex text-muted">
                          <h6 className="mr-2 mb-1">Período:</h6>
                          <p className="mb-1" style={{ fontSize: "14px" }}>
                            {` ${formatearFecha(item.fechaComienzo)} - ${formatearFecha(item.fechaFin)}`}
                          </p>
                        </div>
                      </div>
                    ) : (
                      <>
                        <div>
                          <div className="d-flex">
                            <h6 className="mr-2 mb-2" style={{ color: "var(--primary)" }}>
                              Tienes una solicitud para reemplazar a:
                            </h6>
                            <p className="mb-1" style={{ fontWeight: "bold", fontSize: "14px" }}>
                              {searchHolderName(allPis, item.titular)}
                            </p>
                          </div>
                          <div className="d-flex text-muted">
                            <h6 className="mr-2 mb-1">Período:</h6>
                            <p className="mb-1" style={{ fontSize: "14px" }}>
                              {` ${formatearFecha(item.fechaComienzo)} - ${formatearFecha(item.fechaFin)}`}
                            </p>
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                  <div className="m-0 d-flex align-items-center justify-content-end w-100">
                    {item.estado === 1 ? (
                      <button className="btn m-0" type="button" onClick={() => handleChangeProfile(item)} disabled={item.fechaComienzo >= fechaActual}>
                        Cambiar perfil
                      </button>
                    ) : (
                      <div className="m-0 d-flex align-items-center justify-content-end w-100">
                        <button className="btn btn-primary mr-2" type="button" onClick={() => handleAceptedOrRejected(1, item)}>
                          Aceptar
                        </button>
                        <button className="btn" type="button" onClick={() => handleAceptedOrRejected(2, item)}>
                          Rechazar
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </BlurSpinner>
          );
        })}

      {originalUser && (
        <BlurSpinner isLoading={isLoadingAllPis || isLoading}>
          <div className="d-flex justify-content-start align-items-center m-4">
            <div className="border rounded p-2 px-4 mr-2">
              <h6 style={{ fontWeight: "bold", color: "var(--primary)" }}>Estas reemplazando a:</h6>
              <p>{searchHolderName(allPis, currentUser.user.Pi.itemId)}</p>
            </div>
            <button className="btn" type="button" onClick={handleChangeProfile}>
              Volver a mi perfil
            </button>
          </div>
        </BlurSpinner>
      )}
      {!currentOutOfOffice && !currentRemplacing && <br />}
    </div>
  );
};

export default OutOfOffice;
